<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Announcements</h1>
        </div>
        <p>
            The text you enter below will be displayed to all your communities.
            Be sure to include your name so they know it's from you.
        </p>
        <el-form @submit.native.prevent="submit()" style="max-width: 1000px">
            <el-form-item :class="form.state('announcement')">
                <el-input
                    :autosize="{ minRows: 10, maxRows: 10 }"
                    name="announcement"
                    placeholder="Type your announcements here..."
                    type="textarea"
                    v-model="form.announcement"
                />
                <form-feedback :form="form" field="announcement" />
            </el-form-item>
            <el-button
                :loading="form.busy"
                @click="submit()"
                icon="mdi mdi-content-save"
                type="primary"
                >Save Changes
            </el-button>
        </el-form>
    </vue-scroll>
</template>

<script>
import * as Actions from "@/store/constants/actions.js";

export default {
    components: {},
    data() {
        return {
            form: new Form({
                announcement: null,
            }),
        };
    },
    created() {
        this.form.announcement = this.corporation.announcement;
    },
    computed: {
        corporation() {
            return this.$store.state.current_corporation;
        },
    },
    methods: {
        submit() {
            App.put(
                `/web-api/corporation/${this.corporation.id}`,
                this.form
            ).then(() => {
                this.$notify.success({
                    message: `Changes have been saved.`,
                });
                this.$store.dispatch(Actions.FETCH_CURRENT_CORPORATION);
            });
        },
    },
};
</script>
